import { skipToken } from '@reduxjs/toolkit/query/react';

import type { CompanyMembersFilters } from '@/store/api/companyApi';
import type { MembersTableSortDirection } from '@/store/api/userApi';

import {
  useGetCompanyMembersQuery,
  useGetCompanyQuery,
  useGetCompanySessionsQuery,
} from '@/store/api/companyApi';

// TODO: Make this consistent with other hooks
export const useCompany = (companyId: string) => {
  const {
    data: companyData,
    isLoading: isCompanyLoading,
    refetch: refetchCompany,
  } = useGetCompanyQuery(companyId || skipToken);

  return {
    companyData,
    isCompanyLoading,
    refetchCompany,
  };
};

export const useCompanyMembers = (
  companyId: string,
  isActive = true,
  page = 1,
  limit = 20,
  sortBy?: string,
  sortDirection?: MembersTableSortDirection,
  search?: string,
  filters?: CompanyMembersFilters,
) =>
  useGetCompanyMembersQuery(
    companyId
      ? {
          companyId,
          filters,
          isActive,
          limit,
          page,
          search,
          sortBy,
          sortDirection,
        }
      : skipToken,
  );

export const useCompanySessions = (companyId: string) =>
  useGetCompanySessionsQuery(companyId || skipToken);
